import { useCallback } from 'react';
import { useChargebeeCheckout } from 'src/common/hooks/use-chargebee-checkout';
import { CheckoutType } from 'src/common/hooks/use-chargebee-checkout/use-chargebee-checkout.types';
import { useGetSubscriptionPricingQuery } from 'src/features/pricing/pricing.slice';
export const usePromoteCheckout = () => {
  const {
    openCheckout,
    isLoading: isCheckoutLoading
  } = useChargebeeCheckout(CheckoutType.SUBSCRIPTION);
  const {
    data: pricingData,
    isLoading: isPricingLoading,
    error
  } = useGetSubscriptionPricingQuery(false);
  const isLoading = isCheckoutLoading || isPricingLoading;
  const onCheckout = useCallback(() => {
    const planId = pricingData?.data?.yearlyPlan?.planId;
    if (planId) openCheckout?.({
      planId
    });
  }, [pricingData, openCheckout]);
  return {
    isLoading,
    onCheckout,
    isError: !!error
  };
};